import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

const ReviewSlider = ({ reviews }) => {
  return (
    <Carousel className="w-full max-w-5xl mx-auto" data-testid="review-slider">
      <CarouselContent>
        {reviews.map((review, index) => (
          <CarouselItem key={review.id} className="md:basis-1/2 lg:basis-1/3">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Card className="review-card h-full" data-testid={`review-card-${index}`}>
                <CardContent className="p-6">
                  <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <Star 
                        key={i} 
                        className={`w-4 h-4 ${
                          i < review.rating ? 'fill-accent text-accent' : 'text-gray-300'
                        }`}
                      />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">
                    "{review.comment}"
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {review.keywords.map((keyword, idx) => (
                      <span 
                        key={idx}
                        className="bg-secondary text-primary text-xs px-3 py-1 rounded-full font-medium"
                      >
                        {keyword}
                      </span>
                    ))}
                  </div>
                  <p className="text-sm font-medium text-primary">
                    — {review.guest_name}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden md:flex" />
      <CarouselNext className="hidden md:flex" />
    </Carousel>
  );
};

export default ReviewSlider;